import React from 'react';
import {useTheme} from '@material-ui/core/styles';
import TableRow from '@material-ui/core/TableRow';
import TablePagination from '@material-ui/core/TablePagination';
import TablePaginationActions from "./TablePaginationActions";
import useMediaQuery from '@material-ui/core/useMediaQuery';

const TablePager = (props: any) => {
    const theme = useTheme();
    const notMobile = useMediaQuery(theme.breakpoints.up('sm'));

       return <TableRow>
                <TablePagination
            rowsPerPageOptions={notMobile ? [5, 10, 25] : []}
            count={props.count}
            rowsPerPage={props.rowsPerPage}
            page={props.page}
            SelectProps={{
                inputProps: { 'aria-label': 'rows per page' },
                native: true,
            }}
            onPageChange={props.handleChangePage}
            onRowsPerPageChange={props.handleChangeRowsPerPage}
            ActionsComponent={TablePaginationActions}
        />
    </TableRow>
}

export default TablePager;
